/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OpenGoal Platform API
 * Agency-facing API — day-to-day platform usage by agency users.
 * OpenAPI spec version: 1.0
 */

export type ContractsControllerRenewalsV1Bucket = typeof ContractsControllerRenewalsV1Bucket[keyof typeof ContractsControllerRenewalsV1Bucket];


export const ContractsControllerRenewalsV1Bucket = {
  expired: 'expired',
  within_30: 'within_30',
  within_60: 'within_60',
  within_90: 'within_90',
  within_180: 'within_180',
  within_365: 'within_365',
} as const;
